import { Descendant } from "slate";
import {
  salutationEjsPlaceholder,
  salutationLabel,
  salutationPlaceholder,
} from "./components/ToolbarButtons";

// Document shown in editor upon render
export const defaultDocument: Descendant[] = [
  {
    type: "paragraph",
    children: [
      {
        text: "Hallo ",
      },
      {
        type: "ejs-placeholder",
        ejs: salutationEjsPlaceholder,
        placeholder: salutationPlaceholder,
        children: [
          {
            text: `{${salutationLabel}}`,
          },
        ],
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "...",
      },
    ],
  },
  {
    type: "paragraph",
    children: [
      {
        text: "Gerne können Sie uns mit Fragen und/oder Anregungen und Feedback unter ",
      },
      {
        type: "link",
        href: "mailto:hallo@happylegal.de",
        children: [
          {
            text: "hallo@happylegal.de",
          },
        ],
      },
      {
        text: " erreichen.",
      },
    ],
  },
];

export const emptyDocument: Descendant[] = [
  {
    type: "paragraph",
    children: [
      {
        text: "",
      },
    ],
  },
];
